import { useListContext } from "@/modules/list";
import { ListTagFilter, ListTagSort } from "@/modules/list-tag";
import { CollapseGhostContainer } from "@/ui/collapse-ghost-container";

import { useParamsPreview } from "../list-params-preview.hook";

import "./list-params-preview-panel.style.less";

export const ListParamsPreviewPanel = () => {
  const { filters, visibleSort } = useListContext();
  const { preview } = useParamsPreview();

  const filtersArray = Object.keys(filters);
  const count = filtersArray.length + visibleSort.length;

  return (
    <CollapseGhostContainer open={!count ? false : preview}>
      <div className="list-params-preview-panel">
        {filtersArray.map((filterKey) => (
          <ListTagFilter key={`filter-${filterKey}`} filterKey={filterKey} />
        ))}
        {visibleSort.map((sortKey) => (
          <ListTagSort key={`sort-${sortKey}`} sortKey={sortKey} />
        ))}
      </div>
    </CollapseGhostContainer>
  );
};
